import { useIsWindowBiggerThan } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { useProductMeta } from '@websrc/Basket/useProductMeta'
import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React, { useContext } from 'react'

import { Button, BUTTON_WIDTH } from '../Button/Button'

export function ComparisonTableProductPageLink({ product }: { product: CSProductDetails }) {
  const t = useStaticText()
  const productMeta = useProductMeta(product.product_number)
  const productPath = `/products`
  const { matomoPageTemplate } = useContext(AppProviderContext)
  const isTablet = !useIsWindowBiggerThan(1023)
  return (
    <div>
      <Button
        color={'blue'}
        colorMode={'light'}
        href={`${productPath}${productMeta.url}`}
        iconName={'ARROW_RIGHT'}
        iconPosition={'left'}
        onClick={() => {
          matomo.trackEvent(
            'engagement',
            matomoPageTemplate,
            ['comparison table'],
            ['link to product:' + product.name],
            'link'
          )
        }}
        removePadding={true}
        size={isTablet ? 'small' : 'medium'}
        target={'_blank'}
        text={t.ecom.learn_more ? t.ecom.learn_more : 'Learn More'}
        type={'tertiary'}
        width={BUTTON_WIDTH.Auto}
      />
    </div>
  )
}
